import { useCallback, useEffect, useState } from 'react';

import { LocalStorage } from 'saddlebag-localstorage';

const STORAGE_NAMESPACE = 'creatorPagesSavedHotels';
const STORAGE_KEY = 'savedHotelIds';

const getStorage = () => new LocalStorage(STORAGE_NAMESPACE);

const readIds = (): Set<string> => {
  try {
    const raw = getStorage().tryGetValue(STORAGE_KEY);
    return new Set(Array.isArray(raw) ? raw : []);
  } catch {
    return new Set();
  }
};

const writeIds = (ids: Set<string>) => {
  try {
    getStorage().trySetValue(STORAGE_KEY, [...ids]);
  } catch {
    // localStorage unavailable — ignore
  }
};

const useSavedHotels = () => {
  const [savedIds, setSavedIds] = useState<Set<string>>(new Set());

  useEffect(() => {
    setSavedIds(readIds());
  }, []);

  const toggle = useCallback((entityId: string) => {
    setSavedIds((prev) => {
      const next = new Set(prev);
      if (next.has(entityId)) {
        next.delete(entityId);
      } else {
        next.add(entityId);
      }
      writeIds(next);
      return next;
    });
  }, []);

  return { savedIds, toggle };
};

export default useSavedHotels;
